import React from 'react';
import PropTypes from 'prop-types';
import WithHover from 'WithHover';
import {
  DesktopAndTablet,
} from 'Responsive';

const imgStyle = {
  width: 18,
  marginRight: 13,
};

const textStyle = {
  display: 'inline',
  verticalAlign: 'middle',
};

export const RankBrain2SidebarToggleButton = (props) => {
  const imgSrc = props.isHover ? props.hoverImgSrc : props.imgSrc;

  return (
    <button
      className={`rank-brain-2-sidebar-toggle-button ${props.className}`}
      onClick={props.toggleSideBar}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
    >
      <img alt="Click to toggle" style={imgStyle} src={imgSrc} />
      <DesktopAndTablet>
        {
          props.includeText &&
            <h3 style={textStyle}>
              SECTIONS
            </h3>
        }
      </DesktopAndTablet>
    </button>
  );
};

RankBrain2SidebarToggleButton.defaultProps = {
  isHover: false,
  includeText: true,
  className: 'pull-right',
};

RankBrain2SidebarToggleButton.propTypes = {
  className: PropTypes.string,
  onMouseOut: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  toggleSideBar: PropTypes.func.isRequired,
  isHover: PropTypes.bool,
  includeText: PropTypes.bool,
  imgSrc: PropTypes.string.isRequired,
  hoverImgSrc: PropTypes.string.isRequired,
};

const RankBrain2SidebarToggleButtonWithHover = WithHover(RankBrain2SidebarToggleButton);

export default RankBrain2SidebarToggleButtonWithHover;



// WEBPACK FOOTER //
// ./src-react/RankBrain2SidebarToggleButton/index.jsx